import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import Alpine from 'alpinejs';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initIntroCtaEntriesCards() {
  Alpine.data(
    'introCtaEntriesCards',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        document.addEventListener('DOMContentLoaded', () => {
          // @ts-ignore
          const swiperEl = this.$el.querySelector('.intro-cta-entries-card-swiper');
          if (swiperEl) {
            this.initSwiper(swiperEl as HTMLElement);
          }
        });
      },
      initSwiper(domEl: HTMLElement) {
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          slidesPerView: 3,
          spaceBetween: 16,
          loop: true,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
          },
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .intro-cta-entries-card-next-btn`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .intro-cta-entries-card-prev-btn`,
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
            },
            1200: {
              slidesPerView: 3,
            },
          },
        });
      },
    }),
  );
}
